export const createOOIWebBILogger = _ref => {
  let user = _ref.user,
    biToken = _ref.biToken,
    defaults = _ref.defaults,
    biLoggerFactory = _ref.biLoggerFactory;
  const defaultEventArgs = {
    ...defaults,
    bi_token: biToken,
    ...user
  };
  let loggerFactory = biLoggerFactory({
    host: undefined
  });
  if (loggerFactory.factory) {
    loggerFactory = loggerFactory.factory({
      host: undefined
    });
  }
  return loggerFactory.updateDefaults(defaultEventArgs).logger();
};
export const createBILogger = (controllerConfig, viewerContext, artifactName) => {
  const bi = controllerConfig.platformAPIs.bi;
  const user = {
    visitor_id: bi == null ? void 0 : bi.visitorId
  };
  return createOOIWebBILogger({
    biLoggerFactory: controllerConfig.platformAPIs.biLoggerFactory,
    user,
    biToken: bi == null ? void 0 : bi.biToken,
    defaults: {
      storeId: viewerContext.getEcomPlatformInstanceId(),
      editorMode: viewerContext.getDeviceType() === 'Desktop' ? 'desktop' : 'mobile',
      isMerchant: false,
      appName: 'Stores',
      _msid: bi == null ? void 0 : bi.metaSiteId,
      ...(artifactName ? {
        _artifact_name: artifactName
      } : {})
    }
  });
};
//# sourceMappingURL=createBILogger.js.map